import React from 'react';

const Contact: React.FC = () => {
  return (
    <section className="contact section">
      <div className="container">
        <h2>Let's Work Together</h2>
        <p>I'm always interested in new opportunities and exciting projects.</p>
        <div className="contact-links">
          <a href="mailto:suryachandra7221@gmail.com">Email</a>
          <a href="https://www.linkedin.com/in/suryachandra-maddha-68233228a" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="https://github.com/account" target="_blank" rel="noopener noreferrer">GitHub</a>
        </div>
      </div>
    </section>
  );
};

export default Contact;